import React from "react";
import { colours } from "@shared/ui.design-system";
import { svgIcon } from "./payment-icons/Icons.css";

export function PromoCodeCoupon(): JSX.Element {
  return (
    <svg
      className={svgIcon}
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Promo Code coupon icon</title>
      <path
        d="M15.25 0H9.25003C8.83803 0 8.26103 0.239 7.97003 0.53L0.531026 7.969C0.390758 8.10993 0.312012 8.30067 0.312012 8.4995C0.312012 8.69833 0.390758 8.88907 0.531026 9.03L6.97003 15.469C7.11095 15.6093 7.30169 15.688 7.50053 15.688C7.69936 15.688 7.8901 15.6093 8.03103 15.469L15.47 8.03C15.762 7.738 16 7.162 16 6.75V0.75C15.9992 0.551331 15.92 0.361024 15.7795 0.220543C15.639 0.0800612 15.4487 0.000789946 15.25 0ZM11.5 6C11.303 5.99993 11.1079 5.96106 10.9258 5.88559C10.7438 5.81012 10.5784 5.69954 10.4392 5.56016C10.2999 5.42078 10.1894 5.25533 10.1141 5.07325C10.0387 4.89118 9.99996 4.69605 10 4.499C10.0001 4.30195 10.039 4.10685 10.1144 3.92482C10.1899 3.7428 10.3005 3.57742 10.4399 3.43813C10.5792 3.29884 10.7447 3.18837 10.9268 3.11303C11.1088 3.03768 11.304 2.99893 11.501 2.999C11.899 2.99913 12.2806 3.15735 12.5619 3.43884C12.8432 3.72033 13.0012 4.10204 13.001 4.5C13.0009 4.89796 12.8427 5.27956 12.5612 5.56087C12.2797 5.84217 11.898 6.00013 11.5 6Z"
        fill={colours.primary.dark}
      />
    </svg>
  );
}
